export const MESSAGE_TYPE_CONSTANT = Object.freeze({
    TEXT: 1,
    FILE: 2,
    LOCATION: 3,
    CONTACT: 4,
    STICKER: 5
});